// toast-plugin
import toast from 'jquery-toast-plugin';

/*
 * flashメッセージ
 */
jQuery(function($){
	// 成功
	if ($('.flash-message.success').length > 0){
		var sMessage = $('.flash-message.success').find('.text').text();
		$.toast({
			heading: '成功しました！',
			text: sMessage,
			showHideTransition: 'slide',
			icon: 'success',
			position: 'bottom-right',
			hideAfter: 4000
		});
	}
	// 失敗
	if ($('.flash-message.failure').length > 0){
		var sMessage = $('.flash-message.failure').find('.text').text();
		$.toast({
			heading: '失敗しました',
			text: sMessage,
			showHideTransition: 'slide',
			icon: 'error',
			position: 'bottom-right',
			hideAfter: false
		});
	}
});